import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/AreaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleSection"] */ "/vercel/path0/src/components/sections/ArticleSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/FaqSection.tsx");
